import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { ERROR } from '@/main/store/actionTypes';
import { NdSklad } from '@/modules/sklad/ndSklad';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations, editActions } from './types';

const edit = {
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	FakturaceprofilId: null as number | null,
	NdNr: null as string | null,
	NdPopis: null as string | null,
	PcSmluv: null as number | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VyrobekndOzn: null as string | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: { VyrobekndOzn: [] },
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {
		ndText: null as string | null,
	},
	extraActions: {
		async [editActions.ND_SKLAD_SELECT_MAPPER]({ state, commit, dispatch }, { data }) {
			const dataForMutation = {
				NdNr: null as number | null,
				NdPopis: null as string | null,
				VyrobekndOzn: null as string | null,
			};
			dataForMutation.NdNr = data.ndnr;
			dataForMutation.NdPopis = data.text;
			try {
				const { data: ndSkladEntity } = await NdSklad.apiProvider.entity(data.value);
				dataForMutation.VyrobekndOzn = ndSkladEntity.VyrobekndOzn;
			} catch (err) {
				dispatch(ERROR, { stateKey: state.name, err }, { root: true });
			} finally {
				commit(editMutations.ND_SKLAD_SELECT_MAPPER, { data: dataForMutation });
			}
		},
	},
	extraMutations: {
		[editMutations.ND_SKLAD_SELECT_MAPPER](state, { data }) {
			state.edit.NdNr = data.NdNr;
			state.edit.NdPopis = data.NdPopis;
			state.edit.VyrobekndOzn = data.VyrobekndOzn;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
